import "../styles/components/Loader.css";

const Loader = () => {
  return (
    <div className="loading-animation">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
